<template>
    <div>
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">
            Introduzca el código de autenticación:
            </p>
        <el-form
            @submit.prevent.native="doLoginOTP('otpLoginForm')"
            class="px-4 sm:px-0"
            :model="otpLoginForm"
            :rules="otpLoginRules"
            ref="otpLoginForm"
            novalidate
        >
        <el-form-item  prop="codigo" class="mb-2">
            <el-input
            placeholder="Código "
            type="codigo"
            class="mb-2 custom__icons static-css"
            v-model="otpLoginForm.codigo"
            maxlength='6'
            >
            <i slot="prefix" class="el-input__icon">
                <BaseIcon size="sm"  name="lock" />
            </i>
            <template v-if="otpLoginForm.codigo" slot="suffix">
              <base-clear-input-button
                aria-label="Limpiar campo de código OTP"
                @clear="otpLoginForm.codigo = ''"
              />
            </template>
          </el-input>
        </el-form-item>
            <div class="flex items-center justify-end ">
              <span class="block text-sm font-semibold text-staticprimary-800 dark:text-staticdarkblue-200 cursor-pointer hover:text-staticprimary"
                @click="cleanToggleForms()"
                >Volver a inicio de sesión</span>
            </div>
            <base-button
            class="w-full mt-4"
            mode="staticprimary"
            text="Acceder"
            type="submit"
            :loading = "loader"
            />
        </el-form>
    </div>
</template>

<script>
export default {
  name: 'otp-login-form',
  data: function () {
    return {
      loader: false,
      otpLoginForm: {
        codigo: '',
      },
      otpLoginRules: {
        codigo: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    cleanToggleForms () {
      this.$emit('cleanToggleForms')
    },
    doLoginOTP: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loader = true
            await this.$store.dispatch('auth/checkOTPLogin', { otpCode: this.otpLoginForm.codigo })
            // await this.$store.dispatch('app/getAnnouncementsList')
          } catch (error) {
            if (error !== undefined && error.blnError) {
              this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
            } else {
              this.doFeedback()
            }
          } finally {
            this.loader = false
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
  }
}
</script>

<style scoped>
.dark .el-input .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>
